import { Dialog, DialogContent, DialogTitle, Box, Button } from "@mui/material";
import React from "react";
import { Cross } from "../assets/icons";
import Styles from "../../styles/vendorDashboard.module.css";


const CampaignViewModal = ({ isViewModal, setIsViewModal, campaignData }) => {
  const handleClose = () => {
    setIsViewModal(false);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // short month format (e.g., Oct)
    const year = date.getFullYear().toString().slice(-2); // last two digits of the year
    return `${day} ${month} ${year}`;
  };

  const campaignDetails = [
    {
      label: "Product Category",
      value: "Backlit Signage",
    },
    { label: "Services",
      value: "Recce, Manufacturing, Installation, Audit" ,

    },

    { label: "Experience", value: "2 Years"},
    { label: "Total Area", value: "12728 Sq.Ft" },
    
   
  ];

 const data= [
    {
      "s_no": 1,
      "store_name": "Ramesh Enterprises",
      "store_manager": {
        "name": "Ramesh Singh",
        "contact": "+91 9236729368"
      },
      "address": "Plot No. 1, Sector-74A, Near Milan Restaurant",
      "pin_code": "901283",
      "city_state": "Noida, Uttar Pradesh",
      "width": "4 Ft. 2 In.",
      "height": "4 Ft. 2 In.",
      "thickness": "4 In."
    },
    {
      "s_no": 2,
      "store_name": "Ramesh Enterprises",
      "store_manager": {
        "name": "Ramesh Singh",
        "contact": "+91 9236729368"
      },
      "address": "Plot No. 1, Sector-74A, Near Milan Restaurant",
      "pin_code": "901283",
      "city_state": "Noida, Uttar Pradesh",
      "width": "4 Ft. 2 In.",
      "height": "4 Ft. 2 In.",
      "thickness": "4 In."
    },
    {
      "s_no": 3,
      "store_name": "Ramesh Enterprises",
      "store_manager": {
        "name": "Ramesh Singh",
        "contact": "+91 9236729368"
      },
      "address": "Plot No. 1, Sector-74A, Near Milan Restaurant",
      "pin_code": "901283",
      "city_state": "Noida, Uttar Pradesh",
      "width": "4 Ft. 2 In.",
      "height": "4 Ft. 2 In.",
      "thickness": "4 In."
    }
  ]

  const machinesData = [
    {
      name: "Welding Machine",
      subCategory: "Backlit Signage",
      ampereOfMachine: "Recce, Manufacturing, Installation, Audit",
      controllerSetting: "2 Years",
      ageOfMachine: "12782 Sq. Ft.",
    },
    {
      name: "Paint Compressor Machine",
      subCategory: "Backlit Signage",
      ampereOfMachine: "Recce, Manufacturing, Installation, Audit",
      controllerSetting: "",
      ageOfMachine: "",
    },
  ];

const printingMachinesData = [
  {
    name: "Solvent Printing",
    printerHead: "Printer Head Name",
    brand: "Brand Name",
    picoliter: "Picoliter",
    machineWidth: "6 Ft.",
    machineAge: "3 Years",
  },
  {
    name: "Paint Compressor Machine",
    printerHead: "Printer Head Name",
    brand: "Brand Name",
    picoliter: "Picoliter",
    machineWidth: "6 Ft.",
    machineAge: "3 Years",
  },
];

const fabricationData = [
  {
    category: "Mechanical",
    specifications: [
      { label: "Frame Sections", value: "Printer Head Name" },
      { label: "Frame Wall Thickness", value: "Brand Name" },
      { label: "Approx. Frame Weight", value: "Picoliter" },
      { label: "Size", value: "6 Ft." },
      { label: "Backing Material", value: "3 Years" },
      { label: "Backing Thickness", value: "12782 Sq. Ft." },
      { label: "Backing Grade", value: "6 Ft." },
      { label: "Raising Height", value: "3 Years" },
      { label: "Raising Material", value: "12782 Sq. Ft." },
      { label: "Raising Thickness", value: "6 Ft." },
      { label: "Raising Grade", value: "3 Years" },
      { label: "Application Place", value: "12782 Sq. Ft." },
      { label: "Face", value: "6 Ft." },
      { label: "Additional Specifications", value: "3 Years" },
    ],
  },
  {
    category: "Electrical",
    specifications: [
      { label: "Light Source Type", value: "Printer Head Name" },
      { label: "Light Source Brand", value: "Brand Name" },
      { label: "Light Source Model Number", value: "Picoliter" },
      { label: "Light Source Quantity", value: "6 Ft." },
      { label: "Light Source Color Temp", value: "3 Years" },
      { label: "Light Source Wattage", value: "12782 Sq. Ft." },
      { label: "Wiring Size", value: "6 Ft." },
      { label: "Wiring Type", value: "3 Years" },
      { label: "Wiring Brand", value: "12782 Sq. Ft." },
    ],
  },
  {
    category: "Paint",
    specifications: [{ label: "Paint", value: "Printer Head Name" }],
  },
];

const printingData = [
  {
    category: "Print Specifications",
    specifications: [
      { label: "Print Material Substrate", value: "Printer Head Name" },
      { label: "Print Material Brand", value: "Brand Name" },
      { label: "Print Material Guide", value: "Picoliter" },
      { label: "Art Work (Max Size)", value: "6 Ft." },
      { label: "Substrate Thickness (GSM/Mm)", value: "3 Years" },
      { label: "Outer Size", value: "12782 Sq. Ft." },
      { label: "Brand", value: "6 Ft." },
      { label: "Application Place", value: "3 Years" },
      { label: "Installation Wall", value: "12782 Sq. Ft." },
      { label: "Installation Ceiling", value: "6 Ft." },
      { label: "Installation Projected", value: "3 Years" },
      { label: "Installation Floor", value: "12782 Sq. Ft." },
      { label: "Installation Table Top", value: "6 Ft." },
      { label: "Print DPI", value: "3 Years" },
      { label: "Color Code", value: "12782 Sq. Ft." },
      { label: "Type Of Color Code", value: "6 Ft." },
      { label: "Layer", value: "3 Years" },
      { label: "Passes", value: "12782 Sq. Ft." },
      { label: "Print On Slides", value: "6 Ft." },
    ],
  },
  {
    category: "Electrical",
    specifications: [
      { label: "Print DPI", value: "3 Years" },
      { label: "Color Code", value: "12782 Sq. Ft." },
      { label: "Type Of Color Code", value: "6 Ft." },
      { label: "Layer", value: "3 Years" },
      { label: "Passes", value: "12782 Sq. Ft." },
      { label: "Print On Slides", value: "6 Ft." },
    ],
  },
  {
    category: "Paint",
    specifications: [{ label: "Paint", value: "Printer Head Name" }],
  },
];


   const renderSection = (title, data) => (
    <div>
      <h3 className="text-xl font-bold  text-gray-600 mb-4">{title}</h3>
      <hr/>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="flex flex-col">
              <span className="font-bold text-gray-600">{item.label}:</span>
              <span className="text-gray-600 break-words">
                {item.value || "N/A"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
  return (
    <Dialog open={isViewModal} maxWidth="xl">
      <div className={`flex justify-between ${Styles.vendorModalColor}`}>
        <DialogTitle>Campaign Details </DialogTitle>
        <div
          onClick={handleClose}
          className="mx-5 my-4"
          style={{ cursor: "pointer" }}
        >
          <Cross />
        </div>
      </div>
      <DialogContent className={Styles.vendorModalColor}>
        <Box>
          <div className="flex items-center justify-between">
        <div className="text-center mb-4 bg-white rounded-lg shadow-md p-6 mb-4 w-96">
                  <img
                    src={
                     "/assests/AdminDashboard/vendorImg.jpg"
                    }
                    alt="Profile Logo"
                    className="w-28 h-28 rounded-full mx-auto mb-4 cursor-pointer"
              
                  
                  />
                  <h2 className="text-xl font-semibold">
                   Company Name
                  </h2>
                  <p className="text-gray-500">
                  Company name
                  </p>
                </div>
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4 ml-4">
                {renderSection("Campaign Info", campaignDetails )}
                </div>
               
                </div>
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                <div>
                  <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Product Rendition Reference</h3>
      <Button>
                View CAD File     
      </Button>
                  </div>
      
      <hr/>
      <div className="flex justify-center items-center mt-2"> 
      <img
                    src={
                     "/assests/AdminDashboard/vendorImg.jpg"
                    }
                    alt="Profile Logo"
                    className=" rounded-full mx-auto mb-4 cursor-pointer"
              
                  
                  />
      </div>
    </div>
                </div>
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                <div>
                  <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Sites</h3>
                  </div>
      
      <hr/>
      <div className="flex justify-center items-center mt-2"> 
      <div className="overflow-x-auto border rounded-lg">
        <table className="min-w-full bg-white border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              {[
                "S. No.",
                "Store Name",
                "Store Manager",
                "Address",
                "Pin Code",
                "City/State",
                "Width",
                "Height",
                "Thickness",
              ].map((header) => (
                <th key={header} className="text-left px-4 py-2">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-2 text-sm">{item.s_no}</td>
                <td className="px-4 py-2 text-sm">{item.store_name}</td>
                <td className="px-4 py-2 text-sm">
                  {item.store_manager.name} <br />
                  <span className="text-gray-500 text-xs">{item.store_manager.contact}</span>
                </td>
                <td className="px-4 py-2 text-sm">{item.address}</td>
                <td className="px-4 py-2 text-sm">{item.pin_code}</td>
                <td className="px-4 py-2 text-sm">{item.city_state}</td>
                <td className="px-4 py-2 text-sm">{item.width}</td>
                <td className="px-4 py-2 text-sm">{item.height}</td>
                <td className="px-4 py-2 text-sm">{item.thickness}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
                </div>
                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Fabrication Machines Required</h3>
                  </div>
      <hr/>
      {machinesData.map((machine, index) => (
        <div key={index} className="bg-white shadow-sm rounded-lg p-4 mb-4 mt-4 border">
          <h3 className="text-lg font-semibold border-b pb-2">{machine.name}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
            <div>
              <p className="font-semibold">Sub Category</p>
              <p>{machine.subCategory}</p>
            </div>
            <div>
              <p className="font-semibold">Ampere Of Machine</p>
              <p>{machine.ampereOfMachine}</p>
            </div>
            {machine.controllerSetting && (
              <div>
                <p className="font-semibold">Controller Setting</p>
                <p>{machine.controllerSetting}</p>
              </div>
            )}
            {machine.ageOfMachine && (
              <div>
                <p className="font-semibold">Age Of Machine</p>
                <p>{machine.ageOfMachine}</p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
                </div> 
             

                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Printing machines Required</h3>
                  </div>
      <hr/>
      {printingMachinesData.map((machine, index) => (
        <div key={index} className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
          <h3 className="text-lg font-semibold border-b pb-2">{machine.name}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
            <div>
              <p className="font-semibold">Type Of Printer Head</p>
              <p>{machine.printerHead}</p>
            </div>
            <div>
              <p className="font-semibold">Brand</p>
              <p>{machine.brand}</p>
            </div>
            <div>
              <p className="font-semibold">Picoliter</p>
              <p>{machine.picoliter}</p>
            </div>
            <div>
              <p className="font-semibold">Machine Width</p>
              <p>{machine.machineWidth}</p>
            </div>
            <div>
              <p className="font-semibold">Machine Age</p>
              <p>{machine.machineAge}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
                </div> 

                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Fabrication Material Specifications</h3>
                  </div>
      <hr/>
      {fabricationData.map((section, index) => (
        <div key={index} className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
          <h3 className="text-lg font-semibold border-b pb-2">{section.category}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
            {section.specifications.map((spec, idx) => (
              <div key={idx}>
                <p className="font-semibold">{spec.label}</p>
                <p>{spec.value}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
                </div> 

                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                <div className="rounded-lg">
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-bold  text-gray-600 mb-4">Printing Material Specifications</h3>
                  </div>
      <hr/>
      {printingData.map((section, index) => (
        <div key={index} className="bg-white shadow-sm rounded-lg p-4 mb-4 border">
          <h3 className="text-lg font-semibold border-b pb-2">{section.category}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 text-sm text-gray-700">
            {section.specifications.map((spec, idx) => (
              <div key={idx}>
                <p className="font-semibold">{spec.label}</p>
                <p>{spec.value}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
                </div> 
        </Box>
        {/* <table className="table-auto border-collapse w-full">
          <tbody>
            {campaignDetails.map((item, index) => (
              <tr key={index}>
                <td
                  className="border px-4 py-2"
                  style={{ color: "var(--heading-color)", width: "50%" }}
                >
                  {item.label}
                </td>
                <td
                  className="border px-4 py-2"
                  style={{ color: "var(--para-color)", width: "50%" }}
                >
                  {item.value || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </DialogContent>
    </Dialog>
  );
};

export default CampaignViewModal;
